import React, { createContext, PropsWithChildren, useContext, useState } from 'react'

interface RightSidebarContextValue {
    isOpen: boolean
    setIsOpen: (open: boolean) => void
    content: React.ReactNode | null
    setContent: (content: React.ReactNode | null) => void
}

const RightSidebarContext = createContext<RightSidebarContextValue | null>(null)

export function RightSidebarProvider({ children }: PropsWithChildren) {
    const [isOpen, setIsOpen] = useState(false)
    const [content, setContent] = useState<React.ReactNode | null>(null)

    return <RightSidebarContext.Provider value={{ isOpen, setIsOpen, content, setContent }}>{children}</RightSidebarContext.Provider>
}

export function useRightSidebar(): RightSidebarContextValue {
    const context = useContext(RightSidebarContext)
    if (!context) {
        throw new Error('useRightSidebar must be used within a RightSidebarProvider')
    }

    return context
}
